<form #form="ngForm" (ngSubmit)="confirmSaveItem(itemToSave)" novalidate>
    
      <div class="modal-header">
    <h5 class="modal-title">{{title}}</h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()" aria-label="Fermer"></button>
  </div>
  <div class="modal-body">
    <div class="row">
        <!-- Infos hébergement -->
        <div class="row mb-3 g-2">
            <div class="col-md-4">
                <div class="border rounded p-2 h-100 bg-light">
                    <div class="text-muted small mb-1"><i class="fa fa-user me-1"></i>Client</div>
                    <div class="fw-bold">{{ itemToSave.client_nom }} {{ itemToSave.client_prenom }}</div>
                    <div class="text-muted small">{{ itemToSave.client_telephone }}</div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="border rounded p-2 h-100 bg-light">
                    <div class="text-muted small mb-1"><i class="fa fa-concierge-bell me-1"></i>Service</div>
                    <div class="fw-bold">{{ itemToSave.service_libelle }}</div>
                    <div class="text-muted small">{{ itemToSave.chambre_libelle }}</div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="border rounded p-2 h-100 bg-light">
                    <div class="text-muted small mb-1"><i class="fa fa-sign-in-alt me-1"></i>Entrée</div>
                    <div class="fw-bold">{{ itemToSave.date_debut | date:'dd/MM/yyyy' }}</div>
                    <div class="text-muted small">{{ itemToSave.date_debut | date:'HH:mm' }}</div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="border rounded p-2 h-100 bg-light">
                    <div class="text-muted small mb-1"><i class="fa fa-sign-out-alt me-1"></i>Sortie prévue</div>
                    <div class="fw-bold">{{ itemToSave.date_fin | date:'dd/MM/yyyy' }}</div>
                    <div class="text-muted small">{{ itemToSave.date_fin | date:'HH:mm' }}</div>
                </div>
            </div>
        </div>

        <!-- Formulaire demande -->
        <div class="row g-2 mt-2">
            <div class="col-md-12 mb-2">
                <label class="form-label">Libellé <span class="text-danger">*</span></label>
                <input name="libelle" maxlength="100" [(ngModel)]="itemToSave.libelle"
                    type="text" class="form-control" required />
            </div>
            <div class="col-md-4">
                <label class="form-label">Montant demandé <span class="text-danger">*</span></label>
                <input name="montant_demande" [(ngModel)]="itemToSave.montant_demande"
                    type="number" class="form-control" required />
            </div>
            <div class="col-md-8">
                <label class="form-label">Raison demande <span class="text-danger">*</span></label>
                <textarea name="commentaire_demande" [(ngModel)]="itemToSave.commentaire_demande"
                    class="form-control" rows="2" required></textarea>
            </div>
        </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-danger" (click)="activeModal.dismiss()">Fermer</button>
    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Sauvegarder</button>
  </div>
</form>
